import React, { useContext, useEffect, useState } from 'react';
import { Container, Tabs, Tab, Table, InputGroup, FormControl, Button, Row, Col } from 'react-bootstrap';
import Sidebar from '../../Components/SideBar';
import ApplicationsTab from './ApplicationsTab';
import UserTab from './UserTab';
import Header from '../../Components/Header';
import { ExploreContext } from '../../Context/ExploreContext';
import ToggleSwitch from '../../Components/toogle';
import DemoModal from '../../Components/DemoModal/DemoModal';
import ImageIconLoader from '../../Components/ImageIconLoader';
import { UserContext } from '../../Context/UserContext';
import EnvironmentTab from './EnvironmentTab';
import { useLocation, useNavigate } from 'react-router-dom';
import CagentTab from './CagentTab';

const AdminPanel: React.FC = () => {
  const location = useLocation(); // Obtén la ubicación actual
  const navigate = useNavigate();
  const { getAllAdminApps } = useContext(ExploreContext);
  const { getAllSettings, updateSettings, userData } = useContext(UserContext);
  const [showModal, setShowModal] = useState(false);
  const handleModal = () => setShowModal(!showModal);
  const [dataDemo, setDataDemo] = useState<any>([]);
  const [key, setKey] = useState<string>('users');
  const [collapsed, setCollapsed] = useState(false);
  const [adminApps, setAdminApps] = useState(null);
  const [searchTerm, setSearchTerm] = useState('');
  const [settings, setSettings] = useState<any>({});
  const handleMultipleApps = (id: number) => {

  }
  const toggleSidebar = () => {
    setCollapsed(!collapsed);
  };
  const getSettings = async () => {
    let settings = await getAllSettings();
    setSettings(settings)
  }
  useEffect(() => {
    const hash = window.location.hash.replace('#', '');
    setKey(hash || 'users');
    getSettings()
  }, [window.location.hash]);

  useEffect(() => {
    if (userData) {
      if (!(userData?.role?.id === 1 || userData?.account_id === 1)) {
        window.location.href = "/"
      }
    }
  }, [userData]);

  const handleSelect = (key: string | null) => {
    const aValue = localStorage.getItem("okta-token-storage")!;
    const oktadata = JSON.parse(aValue);
    const okta_id = oktadata.idToken.claims.sub;
    if (key) {
      window.location.hash = key;
      setKey(key);
      setSearchTerm("")
      if (key == "applications") {
        let apps = getAllAdminApps(okta_id)
        setAdminApps(apps)
      }
    }
  };
  const handleFav = (filter: 'favorites' | 'all') => {
    navigate('/home', { state: { filter } });
  };


  const updateSettingsValue = async (name: string, value: any) => {
    await updateSettings(name, value)
    getSettings()
  }
  return (
    <>
      <Container fluid className='position-relative'>
        <Header toggleSidebar={toggleSidebar} collapsed={collapsed} />
        <Row className='main-container'>
          <Col className="p-0" style={{ maxWidth: collapsed ? '80px' : '350px' }}>
            <Sidebar
              collapsed={collapsed}
              onToggle={toggleSidebar}
              handleMultipleApps={handleMultipleApps} />

          </Col>
          <Col className="px-3 transition-all position-realative">
            <div className='pt-3 position-sticky sticky-top bg-white z-1' >
              <h2>Administration</h2>
              {/* Nav tabs */}
              <div className='d-flex admin-subheader'>
                <div className='col-6'>

                  <ul className="nav nav-tabs">
                    <li className="nav-item">
                      {(userData?.role.id == 1 || userData?.account_id == 1) && (
                        <a
                          className={`nav-link ${key === 'users' ? 'active' : ''}`}
                          href="#users"
                          onClick={() => handleSelect('users')}
                        >
                          Users
                        </a>
                      )}
                    </li>

                    {userData?.role.id === 1 && (
                      <li className="nav-item">
                        <a
                          className={`nav-link ${key === 'applications' ? 'active' : ''}`}
                          href="#applications"
                          onClick={() => handleSelect('applications')}
                        >
                          Applications
                        </a>
                      </li>
                    )}
                    {userData?.role.id === 1 && (
                      <li className="nav-item">
                        <a
                          className={`nav-link ${key === 'environment' ? 'active' : ''}`}
                          href="#environment"
                          onClick={() => handleSelect('environment')}
                        >
                          Environment
                        </a>
                      </li>)}
                      {userData?.role.id === 1 && (
                      <li className="nav-item">
                        <a
                          className={`nav-link ${key === 'ai-agent' ? 'active' : ''}`}
                          href="#ai-agent"
                          onClick={() => handleSelect('ai-agent')}
                        >
                         AI Agent
                        </a>
                      </li>)}

                  </ul>
                </div>
                {key === 'users' && <div className="col-8 d-flex">
                  <div className="col-6 text-end ">
                    <Button className='text-dark bg-3 fw-bold' href='https://admin.graydi.io/' target='_blank'>
                    Account Management Portal
                    </Button>
                  </div>
                  <div className="col-6">

                    <InputGroup className="search-input ">
                      <FormControl
                        placeholder="Search"
                        className='transparent-input'
                        value={searchTerm}
                        onChange={e => setSearchTerm(e.target.value)}
                      />
                      <InputGroup.Text className="search-icon transparent-input">
                        <ImageIconLoader name={"iconsearch"} alt="Search Icon" width={18} />
                      </InputGroup.Text>
                    </InputGroup>
                  </div>

                </div>}

                {key === 'applications' && <div className="col-6 d-flex justify-content-end">
                  {/* <div className="m-1">
                    <ToggleSwitch isOnCloud={settings.type_link} setIsOnCloud={updateSettingsValue} />
                  </div> */}
                  <div className="m-1">
                    <Button className='text-dark bg-3 fw-bold border-0' href='https://grayassociates-admin.okta.com' target="_blank">Okta Admin</Button>

                  </div>
                  <div className="m-1">

                    <InputGroup className="search-input ">
                      <FormControl
                        placeholder="Search"
                        className='transparent-input'
                        value={searchTerm}
                        onChange={e => setSearchTerm(e.target.value)}
                      />
                      <InputGroup.Text className="search-icon transparent-input">
                        <ImageIconLoader name={"iconsearch"} alt="Search Icon" width={18} />
                      </InputGroup.Text>
                    </InputGroup>
                  </div>


                </div>}

              </div>
            </div>

            {/* Tab content */}
            <div className="tab-content mt-3">
              {key === 'users' && <UserTab searchTerm={searchTerm} />}
              {key === 'applications' && <ApplicationsTab searchTerm={searchTerm} />}
              {key === 'environment' && <EnvironmentTab />}
              {key === 'announcements' && <AnnouncementsTab />}
              {key === 'ai-agent' && <CagentTab />}
              {key === 'support' && <SupportTab />}
            </div>
          </Col>
        </Row >
      </Container >
      <DemoModal showModal={showModal} handleModal={handleModal} dataDemo={dataDemo} />
    </>
  );
};


// Componente para la pestaña "Announcements"
const AnnouncementsTab: React.FC = () => {
  return (
    <div>
      <h4>Announcements Tab Content</h4>
      {/* Aquí puedes agregar contenido específico de la pestaña "Announcements" */}
    </div>
  );
};

// Componente para la pestaña "Support"
const SupportTab: React.FC = () => {
  return (
    <div>
      <h4>Support Tab Content</h4>
      {/* Aquí puedes agregar contenido específico de la pestaña "Support" */}
    </div>
  );
};

export default AdminPanel;
